const UTMManager = {
  storageKey: 'cg_utm_data',
  expirationDays: 5,

  getUTMFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });

    return Object.keys(utmParams).length > 0 ? utmParams : null;
  },

  saveUTM(utmData) {
    const expirationTime = new Date().getTime() + (this.expirationDays * 24 * 60 * 60 * 1000);
    const dataToStore = {
      utm: utmData,
      expiration: expirationTime
    };
    localStorage.setItem(this.storageKey, JSON.stringify(dataToStore));
  },

  getStoredUTM() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (!stored) return null;

      const data = JSON.parse(stored);
      const now = new Date().getTime();

      if (now > data.expiration) {
        this.clearUTM();
        return null;
      }

      return data.utm;
    } catch (e) {
      console.error('Błąd podczas pobierania danych UTM:', e);
      return null;
    }
  },

  clearUTM() {
    localStorage.removeItem(this.storageKey);
  },

  addUTMFieldsToForm(form) {
    const utmData = this.getStoredUTM();
    if (!utmData) return;

    const existingFields = form.querySelectorAll('input[name^="utm_"]');
    existingFields.forEach(field => field.remove());

    Object.entries(utmData).forEach(([key, value]) => {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = key;
      hiddenInput.value = value;
      form.appendChild(hiddenInput);
    });
  },

  init() {
    const utmFromURL = this.getUTMFromURL();
    if (utmFromURL) {
      this.saveUTM(utmFromURL);
    }

    const forms = document.querySelectorAll('form.wpcf7-form');
    if (forms.length === 0) return;

    forms.forEach(form => {
      this.addUTMFieldsToForm(form);
    });
  }
};

export const thp = () => {
  UTMManager.init();

  const scrollToTopOfTheForm = (scrollElement, offsetElement) => {
    const scrollTopVal = scrollElement.offsetTop - offsetElement.clientHeight - 50
    window.scrollTo({
      top: scrollTopVal,
      behavior: 'smooth',
    });
  };

  const mainForm = document.querySelector('form.main-contact-form');
  if (mainForm) {
    mainForm.addEventListener('submit', function(e) {
      const form = e.target;
      const submitBtn = form.querySelector('button.wpcf7-submit');
      console.log('submitBtn', submitBtn)
      if (submitBtn) {
        submitBtn.classList.add('wpcf7-submit-sending');
        submitBtn.disabled = true;
      }
    });
  }

  ['wpcf7invalid', 'wpcf7spam', 'wpcf7mailfailed'].forEach(function(event) {
    document.addEventListener(event, function(e) {
      const form = e.target;
      const submitBtn = form.querySelector('button.wpcf7-submit');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('wpcf7-submit-sending');
      }
    }, false);
  });

  document.addEventListener(
    'wpcf7mailsent',
    (e) => {
      UTMManager.clearUTM();

      const form = e.target;

      const formHolder = form.closest('#contact')
      const menu = document.querySelector('header')

      // if not main contact form, return
      if (!formHolder) return;

      const createSVG = () => {
        // Create the SVG element
        const svgNS = "http://www.w3.org/2000/svg";
        const svg = document.createElementNS(svgNS, "svg");
        svg.setAttribute("width", "64");
        svg.setAttribute("height", "64");
        svg.setAttribute("viewBox", "0 0 64 64");
        svg.setAttribute("fill", "none");

        // Create the rectangle element
        const rect = document.createElementNS(svgNS, "rect");
        rect.setAttribute("width", "64");
        rect.setAttribute("height", "64");
        rect.setAttribute("rx", "32");
        rect.setAttribute("fill", "#03050A");
        rect.setAttribute("fill-opacity", "0.05");

        // Create the path element
        const path = document.createElementNS(svgNS, "path");
        path.setAttribute("d", "M28.7333 39.9999L21.1333 32.3999L23.0333 30.4999L28.7333 36.1999L40.9666 23.9666L42.8666 25.8666L28.7333 39.9999Z");
        path.setAttribute("fill", "#03050A");

        // Append the rectangle and path to the SVG
        svg.appendChild(rect);
        svg.appendChild(path);

        return svg
      };

      // Call the function to create and append the SVG
      const svg = createSVG();

      const successTitle = document.createElement('h4')
      successTitle.classList.add('title')
      successTitle.innerHTML = 'Dziękujemy za kontakt!'

      const successText = document.createElement('p')
      successText.classList.add('text')
      successText.innerHTML = 'Twoja wiadomość została przesłana i nasi specjaliści skontaktują się z Tobą wkrótce.'

      scrollToTopOfTheForm(formHolder, menu)
      form.classList.add('success-sent')
      setTimeout(() => {
        formHolder.innerHTML = ''
        formHolder.classList.add('success-sent')
        formHolder.appendChild(svg)
        formHolder.appendChild(successTitle)
        formHolder.appendChild(successText)
      }, 500)
    },
    false
  )
}
